import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { labelList, labelStatus, isEditLabel, delLabel } from './request';
import labelModel from './labelModel.vue';
let expandedRowKeys = [];
const rowSelection = {
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
    expandedRowKeys = selectedRows;
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    expandedRowKeys = selectedRows;
  }
};
export default {
  components: {
    labelModel
  },
  data() {
    return {
      categoryShow: false,
      form: {
        name: '',
        classificationId: this.$route.params.id
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [{
        slots: {
          title: '标签名称'
        },
        dataIndex: 'name',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '是否允许编辑'
        },
        dataIndex: 'isEdit',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'isEdit'
        }
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '5',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '操作'
        },
        width: 200,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      expandedRowKeys,
      rowSelection
    };
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    }
  },
  created() {
    this.getTableFun();
  },
  methods: {
    getTableFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      labelList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    getClassificationTable() {
      this.pagination.current = 1;
      this.getTableFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTableFun();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleAdd() {
      this.categoryShow = true;
      this.$nextTick(() => {
        this.$refs.categoryForm.init({});
      });
    },
    handleEdit(val) {
      this.categoryShow = true;
      this.$nextTick(() => {
        this.$refs.categoryForm.init(val);
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该分类') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delLabel({
          labelIds: val.labelId
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getTableFun();
        });
      });
    },
    checkedFun(val) {
      console.log(val);
      if (!this.isAuth('home.insuranceLabelStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      labelStatus({
        labelId: val.labelId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '!');
        val.status = val.status == 1 ? 0 : 1;
      });
    },
    checkedFun2(val) {
      console.log(val);
      if (!this.isAuth('home.insuranceLabelIsEdit')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      isEditLabel({
        labelId: val.labelId,
        isEdit: val.isEdit == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '!');
        val.isEdit = val.isEdit == 1 ? 0 : 1;
      });
    },
    handleDel() {
      if (expandedRowKeys.length == 0) {
        this.$message.error(this.$t('请选择') + this.$t('要删除的数据'));
        return false;
      }
      let arr = [];
      expandedRowKeys.map(item => {
        arr.push(item.labelId);
      });
      delLabel({
        labelIds: arr.join(',')
      }).then(res => {
        expandedRowKeys = [];
        this.$message.success(this.$t('删除成功') + '!');
        this.getTableFun();
      });
    }
  }
};